import React, { useState } from 'react'
import RepresentMoney from '../../utility/represent-money'
import TicketRow from './ticket-row'
import InfoRow from './info-row'
import * as API from '../../utility/api'

const BASKETS_URL = 'admin/management/baskets'

const BasketBox = (props) => {
  const [open, setOpen] = useState(false)
  const [paymentStatus, setPaymentStatus] = useState(props.payment_status)
  const [fetching, setFetching] = useState({ update: false, process: false })
  const [errors, setErrors] = useState([])

  const {
    reference,
    amount,
    user_iban,
    user_name,
    user_email,
    tickets,
    payment_info,
    stamp
  } = props

  const toggleOpen = () => {
    setOpen(!open)
  }

  const updateBasket = () => {
    setFetching({ ...fetching, update: true })

    API.POST(BASKETS_URL, {
      action: 'update',
      paymentStatus,
      reference,
      stamp
    })
      .then(() => {
        setFetching({ ...fetching, update: false })
      })
      // eslint-disable-next-line
      .catch((e) => {
        setFetching({ ...fetching, update: false })
      })
  }

  const manualProcess = () => {
    setFetching({ ...fetching, process: true })

    API.POST(BASKETS_URL, {
      action: 'process',
      reference,
      stamp
    })
      .then(() => {
        setFetching({ ...fetching, process: false })
      })
      .catch(({ response }) => {
        const errors = response.data

        setFetching({ ...fetching, process: false })
        setErrors(errors)
      })
  }

  const openedContent = (
    <React.Fragment>
      <div className="break-md" />

      {tickets &&
        tickets.map((ticket) => (
          <TicketRow
            key={ticket.id}
            ticket={ticket}
            basket={{ reference, stamp }}
          />
        ))}
    </React.Fragment>
  )

  const paymentStatusInput = (
    <select
      value={paymentStatus}
      onChange={(e) => setPaymentStatus(e.target.value)}
    >
      <option value="" />
      <option value="REJECTED">Hylätty</option>
      <option value="paid">Maksettu</option>
      <option value="not_paid">Ei maksettu</option>
    </select>
  )

  const errorContent = () =>
    errors.map((e) => (
      <div>
        {e}
        <div className="break-sm" />
      </div>
    ))

  return (
    <div
      key={`basket-${reference}`}
      style={{
        backgroundColor: 'floralwhite',
        border: '1px solid',
        marginBottom: '1em'
      }}
    >
      <InfoRow
        first={['Checkout-viite', reference]}
        second={['Summa', <RepresentMoney sum={amount} eurSuffix />]}
        third={['Payment status', paymentStatusInput]}
      />

      <InfoRow
        first={['IBAN', user_iban]}
        second={['Nimi', user_name]}
        third={['Nimi', user_name]}
      />

      <InfoRow
        first={['Email', user_email || 'Käyttäjällä ei emailia']}
        second={['Lippujen määrä', tickets.length]}
        third={[
          'Maksu',
          `${payment_info && payment_info.payment}, status=${
            payment_info && payment_info.payment_status
          }`
        ]}
      />

      {open && openedContent}

      <div className="basket--management--row">
        <button
          style={{ flex: 1, margin: '10px' }}
          onClick={() => toggleOpen()}
        >
          {open ? 'SULJE' : 'AVAA'}
        </button>

        <button style={{ flex: 1, margin: '10px' }} onClick={updateBasket}>
          {fetching.update ? 'Tallennetaan…' : 'Tallenna'}
        </button>

        <button style={{ flex: 1, margin: '10px' }} onClick={manualProcess}>
          {fetching.process ? 'PROCESSING………' : 'MANUAL PROCESS'}
        </button>
      </div>
      {errors.length > 0 && (
        <div
          style={{
            color: 'tomato',
            border: '1px solid',
            borderRadius: '5px',
            margin: '10px',
            padding: '0 10px'
          }}
        >
          <div className="break-sm" />
          {errorContent()}
        </div>
      )}
    </div>
  )
}

export default BasketBox
